import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DebugLoggerService {
  private enabled: boolean = false;
  private readonly storageKey = 'spotlight_debug_logging_enabled';

  constructor() {
    // Restore previous state from localStorage
    const saved = localStorage.getItem(this.storageKey);
    if (saved !== null) {
      this.enabled = saved === 'true';
      if (this.enabled) {
        console.log('[DebugLogger] Debug logging restored from previous session');
      }
    }
  }

  /**
   * Toggle debug logging on/off
   * Use Ctrl+Shift+L (or Cmd+Shift+L on Mac) to toggle
   */
  toggle(): void {
    this.enabled = !this.enabled;
    localStorage.setItem(this.storageKey, String(this.enabled));

    const status = this.enabled ? 'ENABLED' : 'DISABLED';
    const style = this.enabled
      ? 'background: #4CAF50; color: white; padding: 4px 8px; border-radius: 3px; font-weight: bold;'
      : 'background: #f44336; color: white; padding: 4px 8px; border-radius: 3px; font-weight: bold;';

    console.log(`%c Debug Logging ${status} `, style);
  }

  /**
   * Check if debug logging is enabled
   */
  isEnabled(): boolean {
    return this.enabled;
  }

  /**
   * Log an error (always shown, regardless of debug state)
   */
  error(message: string, ...args: any[]): void {
    console.error(message, ...args);
  }

  /**
   * Log a warning if debug logging is enabled
   */
  warn(message: string, ...args: any[]): void {
    if (this.enabled) {
      console.warn(message, ...args);
    }
  }

  /**
   * Log info if debug logging is enabled
   */
  info(message: string, ...args: any[]): void {
    if (this.enabled) {
      console.log(message, ...args);
    }
  }
}
